// This file is only a template for services.  Copy and paste this to your application's service .ts file and start off from there
// Rename all things with App_Name.
// Naming convention for services is "[App Name]Services.ts" i.e. UsersServices.ts, EntitlementServices.ts

import BaseService from './../../../services/BaseService';
import UrlUtilities from '../../../common/UrlUtilities';
import assign from 'object-assign';
var url = `${UrlUtilities.getApiUrl()}/UserProfileApi/api/profile`;


var UserProfileServices: IUserProfileService = assign({}, BaseService, {
    getProfile: function (successCallback: any, errorCallback: any) {
        var that = this;
        this.get(url,
            null,
            function (retData: any) {
                successCallback(retData);
            },
            function (error: any) {
                that.handleWebApiError(error);
                errorCallback(error);
            });
    },

    getPasswordSettings: function (successCallback: any, errorCallback: any) {
        var that = this;
        this.get(`${url}/GetPasswordSettings`,
            null,
            function (retData: any) {
                successCallback(retData);
            },
            function (error: any) {
                that.handleWebApiError(error);
                errorCallback(error);
            });
    },

    editUser: function (profile: IUserProfile, successCallback: any, errorCallback: any, ignoreDefaultError: (error: IServiceErrorObject) => boolean) {
        var that = this;
        this.post(`${url}/Update`,
            profile,
            function (retData: any) {
                successCallback(retData);
            },
            function (error: any) {
                if (!ignoreDefaultError(error)) {
                    that.handleWebApiError(error);
                }
                errorCallback(error);
            });
    },

    changePassword: function (oldPassword: string, newPassword: string, successCallback: any, errorCallback: any, ignoreDefaultError: (error: IServiceErrorObject) => boolean) {
        var that = this;
        this.post(`${url}/ChangePassword`,
            { OldPassword: oldPassword, NewPassword: newPassword },
            function (retData: any) {
                successCallback(retData);
            },
            function (error: any) {
                if (!ignoreDefaultError(error)) {
                    that.handleWebApiError(error);
                }
                errorCallback(error);
            });
    }
});

export default UserProfileServices;